import { OrderLines } from '../../api/models/order-simulation';
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { Observable } from 'rxjs/Observable';
import { ProductAliasService } from '../../api/services/product-alias.service';
import { BomLine, BomLineInput, BomLinesRequest } from '../../api/models/bom-line';
import { BomTableRow } from '../../api/models/bom-table-row';
import { ProjectService } from '../../api/services/project.services';
import { Quote, StatusMessageDto } from '../../api/models/quote';
import { OrderDetail } from '../../api/models/order-detail';
import { BehaviorSubject } from 'rxjs';
import { Product } from '../../api/models/product';

@Injectable()
export class BomTableService {

  $quoteDetailsSubject = new Subject<any>();
  $cleanMessagesSubject = new Subject<any>();
  worksheetSaveClicked = new BehaviorSubject(false);
  
  waitingQuoteItems: string[] = [];
  actualQuote: Quote; // to be replaced by mockOrder

  hazmatSkus: string[] = [];
  private bomLines: BomLine[] = [];

  constructor(
    private productAliasService: ProductAliasService,
    private projectService: ProjectService
  ) { }

  getBomLines(bomId: string) {
    return this.projectService.getBomLines(bomId)
      .do(bomLines => this.bomLines = bomLines);
  }

  quickAddItems(bomlineInputList : BomLineInput[]) {
    return this.projectService.quickAddBomLines(bomlineInputList)
      .do(newLine => newLine.forEach(line => this.bomLines.push(line)));
  }

  addItemsV2(bomLineRequest: BomLinesRequest) {
    return this.projectService.createBomLinesV2(bomLineRequest)
        // .do(newLine => this.bomLines.push(newLine));
  }

  deleteBomLines(bombId: string, lineIds: string[]) {
    lineIds.forEach(id => {
      this.projectService.getBomLines(bombId).subscribe(lines => {
        this.bomLines = lines;
      });
      const bomLine = this.bomLines.find(l => l.id === id);
    });
    return this.projectService.deleteBomLines(lineIds)
      .do(() => this.bomLines = this.bomLines.filter(b => !lineIds.includes(b.id)));
  }

  addToRowsInPlaceOrBeginning(rows: BomTableRow[], row: BomTableRow) {
    const index = rows.findIndex(b => b.line.partNumber === row.line.partNumber && b.line.id == row.line.id);
    if (index !== -1) {
      rows[index] = row;
    } else {
      rows.unshift(row);
    }
    return rows;
  }
  
  toTableBomRowsV2(bomLines: BomLine[], accountNumber?: string, orgId?: string): Observable<BomTableRow[]> {
    return this.productAliasService.productDetailsV2(bomLines.map(line => line.partNumber), accountNumber, orgId)
      .map(products => {
        return bomLines.map((value, index) => {
          const product = products.find(item => item.sku === value.partNumber);
          if (product == null) {
            var temp = new Product();
            temp.manufacturerName = 'N/A';
            temp.manufacturerPartNumber = 'N/A';
            temp.name = 'Inactive SKU';
            temp.minimumQuantity = 0;
            temp.returnPolicy = 'N/A';
            temp.unitOfMeasure = 'N/A';
            return { line: value, data: temp };
          }
          if (product != null && product.isHazmatItem) {
            if (!this.hazmatSkus.includes(value.partNumber)) {
              this.hazmatSkus.push(value.partNumber);
            }
          }
          return { line: value, data: product };
        });
      });
  }

  cleanMessages() {
    this.$cleanMessagesSubject.next();
  }

  public setPricingAndAvailabilityDetails(orderLines: OrderLines[]) {
    const stockValueHash = {};
    orderLines.forEach(orderLine => {
      let text, klass, price, availability;
      if (orderLine.quantity <= orderLine.quantityAvailable) {
        text = 'IN';
        klass = 'in-color';
      } else if (orderLine.quantityAvailable > 0) {
        text = 'PARTIAL';
        klass = 'partial-color';
      } else {
        text = 'OUT';
        klass = 'out-color';
      }
      price = orderLine.price;
      availability = {
        qty: orderLine.quantity, qtyAvailable: orderLine.quantityAvailable ? orderLine.quantityAvailable : 0,
        backorderAvailabilities: orderLine.backorderAvailabilities && orderLine.backorderAvailabilities.length ? orderLine.backorderAvailabilities : null
      };
      stockValueHash[orderLine.bomLineId] = { label: text, class: klass, price, availability: availability };
    });
    this.$quoteDetailsSubject.next(stockValueHash);
  }

  isWaitingQuote(lineId: string): boolean {
    if((! this.waitingQuoteItems) || this.waitingQuoteItems.length < 1) {
      return false;
    }
    return this.waitingQuoteItems.includes(lineId);
  }

  hasStatusMessages(): boolean {
    if (this.actualQuote) {
      return this.actualQuote.hasStatusMessages;
    } else {
      return false;
    }
  }

  isCheckoutBlocked(): boolean {
    if (this.actualQuote) {
      return this.actualQuote.isCheckoutBlocked;
    } else {
      return true;
    }
  }

  getStatusMessages(): StatusMessageDto[] {
    return this.actualQuote.statusMessages;
  }

  getWorksheetTotal(): number {
    if (this.actualQuote) {
      return this.actualQuote.totalMerchandiseAmountToShip;
    } else {
      return 0;
    }
  }

  addWaitingQuoteItems(lineIds: string[]): void {
    lineIds.forEach(line => {
      this.waitingQuoteItems.push(line);
    });
  }

  cleanWaitingItems(): void {
    this.waitingQuoteItems = [];
  }

  dismissHazmat() {
    this.hazmatSkus = [];
  }

  findIncompatibleProducts(skus: string[], purchasePlanCode: string): Observable<string[]> {
    return this.productAliasService.findIncompatibleProducts(skus, purchasePlanCode);
  }

  getTotalPrice(orderDetail: OrderDetail) {
    if (orderDetail != null && orderDetail.orderLines != null) {
      let total = 0;
      orderDetail.orderLines.forEach(ol => {
        total = total + ol.quantity * ol.price;
      })
      return total;
    }
  }

}



// WEBPACK FOOTER //
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/app/bom-table/bom-table.service.ts